import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Image from 'gatsby-theme-core/src/components/image';
import PartnersLogosSlider from './slider';

const IntroOverlay = styled.div`
  background-color: transparent;
  text-align: center;
  min-height: 6rem;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 2rem;
    overflow-y: scroll;
    flex-wrap: wrap;
  }
  .gatsby-image-wrapper {
    display: none !important;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
      display: block !important;
    }
  }
`;

const PartnersLogos = ({
  // id,
  columnWidth,
  align,
  justify,
  order,
  offset,
  options,
 }) => {
  const { partners } = useStaticQuery(graphql`
    query PDVPagebuilderStrapiPartnersLogosQuery {
      partners: allStrapiPartners(sort: { priority: ASC }) {
        nodes {
          id
          title
          category
          logo {
            url
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: FIXED
                  placeholder: BLURRED
                  width: 140
                )
              }
            }
          }
        }
      }
    }
  `);

  if (options?.asSlider) {
    return (
      <PartnersLogosSlider partners={partners.nodes} />
    );
  }

  return (
    <Column
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      order={order}
      offset={offset}
    >
      <IntroOverlay>
        {[
          ...partners.nodes.filter(({ category }) => category === 'premium'),
          ...partners.nodes.filter(({ category }) => category === 'podcast'),
          ...partners.nodes.filter(({ category }) => category === 'event'),
          ...partners.nodes.filter(({ category }) => category === 'business'),
        ].map(({ id, title, logo }) => (
          <Image
            key={id}
            image={logo}
            alt={title}
            css="margin: 1rem"
          />
        ))}
      </IntroOverlay>
    </Column>
  );
};

export default PartnersLogos;
